import { CSSProperties, cx, LinariaClassName } from '@linaria/core';
import { memo } from 'react';
import Dot from '../../../common/Dot';
import { getThemeSpacing } from '../../../styles/appTheme';
import "./Online.linaria.module.css!=!./Online?./Online.linaria.module.css?css=H4sIAAAAAAAAA12R0W7CIBSG7/cUu3TJMKN2rbKHIVAoxVFOB9hSyd590VW0Jtx85Ps58LNloafGUF1MoSy3K0oDE0JbhZxWXSDVEL9+X67K55HiuSzBtImDE9Ihx4Q+eVLendpQDkXh69SAAUdG5jYIsZEF5hBnQkkE1mgr324J8017XMdYrylfw8g2LMc8buV8UVHcsXMseOKs+VYOTlYQpzjbfLy/LmtbZb/ZU7yrZXssnjC1YAPy+iyXcZlztj9SZeap7dMA2gbpkBylDZ5YsPImdRR3FRxP5zUlZrSySAfZe9LISzpXIGk4lHPwa8oVcAgBeoLvNRtYJeA5EWB41BtP93aHC76m/xdP8vrRHIzIfqS4/MExdkmxYalDsSEXcfAUhzjp0SSh/WDYTFojL/P+AJVPxPVbAgAA"
interface OnlineBadgeProps {
  fontSize?: number;
  isBroadcasting?: boolean;
  className?: LinariaClassName;
}
const stylesRoot = "atm_ll_i2wt44 atm_5j_1y44olf atm_7l_bo22s7 atm_lk_m17xx7 atm_26_1hazx2b atm_c8_137efj2 atm_mj_glywfm atm_h_1h6ojuz atm_le_t94yts atm_lo_t94yts atm_cs_8n312b atm_cx_14q1xxh atm_9s_1txwivl";
const OnlineBadge = memo((props: OnlineBadgeProps) => {
  const {
    fontSize = 13.5,
    isBroadcasting,
    className
  } = props;
  const compact = fontSize < 12;
  const dotSize = compact ? 5 : 8;
  const dotSpacing = getThemeSpacing(compact ? 0.75 : 1.25);
  return <div data-testid="Badge__Online" className={cx(stylesRoot, className)} style={{
    '--padding-left': dotSpacing,
    '--font-size': fontSize + 'px',
    '--gap': dotSpacing
  } as CSSProperties}>
            <Dot isBroadcasting={isBroadcasting} dotSize={dotSize} haloWidth={0} inline plain />
            Online
        </div>;
});
export default OnlineBadge;
export { OnlineBadge };